import * as React from 'react'
import { StyledImage } from '$views/components/Image/Image.style'

interface Props {
  src: string
  fallback?: string
  type?: string
  height?: number | string
  width?: number | string
  cover?: boolean
  objectPosition?: string
}

export const Image: React.FC<Props> = ({
  src,
  fallback,
  type = 'image/webp',
  height,
  width,
  cover,
  objectPosition,
}) => {
  return (
    <picture style={{ lineHeight: 0 }}>
      {fallback ? (
        <>
          <source srcSet={src} type={type} />
          <StyledImage src={fallback} height={height} width={width} cover={cover} objectPosition={objectPosition} />
        </>
      ) : (
        <StyledImage src={src} height={height} width={width} cover={cover} objectPosition={objectPosition} />
      )}
    </picture>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/Image/Image.tsx